var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#686C70",
    fillOpacity: 0.8,
    transform: "rotate(-180 22 22)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#363E46",
    d: "M.75 22a21.25 21.25 0 1 1 42.5 0 21.25 21.25 0 0 1-42.5 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M.75 22a21.25 21.25 0 1 1 42.5 0 21.25 21.25 0 0 1-42.5 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#b)",
    strokeWidth: 1.5,
    d: "M.75 22a21.25 21.25 0 1 1 42.5 0 21.25 21.25 0 0 1-42.5 0Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 17.08 -21.47 0 21.68 4.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#B6B8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373E46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 21.68,
    x2: 21.68,
    y1: 44.14,
    y2: 0.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#5B5D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7E858F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.a9bd84d9ac4adf11a825b05ec35df8ec.svg";
export { ForwardRef as ReactComponent };